<app-corporate-data  *ngIf="step == 0"></app-corporate-data>
<app-verification-code *ngIf="step == 1"></app-verification-code>
<app-corporate-information *ngIf="step == 2"></app-corporate-information>
<app-information-preview *ngIf="step ==3"></app-information-preview>
<app-success-continue  *ngIf="step == 4"></app-success-continue>
